module.exports = __webpack_public_path__ + "static/media/ic_whatsapp_small.6515fc57.svg";